export default "__VITE_ASSET__DA6teGk___"